/*----- Core -----*/
import React   from 'react'
import styled	 from 'styled-components'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color      from '../../commons/Color'

const StyledSearchResult = styled.article`
	padding: 16px;
	border-bottom: 1px solid lightgrey;
	cursor: pointer;
	max-width: 500px;
	width: 100%;
	display: flex;
  align-items: baseline;
	background-color: white;
	&:last-child {
		border-bottom: none;
	}
	.search-result__title {
		${ Montserrat(14, 700, Color.main) };
		min-width: fit-content;
	}
	.search-result__description {
		${ Montserrat(12, 500, Color.grey) };
		width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 8px;
    border-left: 1px solid grey;
    padding-left: 8px;
	}
`

const SearchResults = ({ product, onClick }) => {
	const { name, description } = product
	return(
		<StyledSearchResult onClick={onClick} className="search-result">
			<div className="search-result__title">
				{name}
			</div>
			<div className="search-result__description">
				{ description }
			</div>
		</StyledSearchResult>
	)
}

export default SearchResults